import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  doc,
  getDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import {
  TextField,
  MenuItem,
  Button,
  Paper,
  CircularProgress,
  Chip,
} from "@mui/material";

import Navbar from "../../Components/Navbar/navbar";
import { db } from "../../Config/firebase";
import RelatorioOcorrenciasPrint from "./RelatorioOcorrenciasPrint";

export default function OcorrenciaDetalhe() {
  const { eventoId } = useParams();
  const history = useHistory();

  const [evento, setEvento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);
  const [exibirRelatorio, setExibirRelatorio] = useState(false);

  /* =========================
     CARREGAR OCORRÊNCIA
  ========================= */
  useEffect(() => {
    async function carregar() {
      try {
        setLoading(true);

        const snap = await getDoc(doc(db, "kpi_eventos", eventoId));

        if (!snap.exists()) {
          setErro("Ocorrência não encontrada");
          return;
        }

        setEvento({ id: snap.id, ...snap.data() });
      } catch (e) {
        console.error(e);
        setErro("Erro ao carregar ocorrência");
      } finally {
        setLoading(false);
      }
    }

    carregar();
  }, [eventoId]);

  /* =========================
     SALVAR TRATAMENTO
  ========================= */
  async function salvar() {
    try {
      setSalvando(true);

      await updateDoc(doc(db, "kpi_eventos", eventoId), {
            referencia: evento.referencia || "", // ✅ ADICIONADO AQUI

            classificacao: evento.classificacao || null,

            // 🔒 só grava tipoNC se for NC
            tipoNC:
              evento.tipoRegistro === "NC"
                ? evento.tipoNC || null
                : null,

            causa: evento.causa || "",
            acaoCorretiva: evento.acaoCorretiva || "",
            acaoPreventiva: evento.acaoPreventiva || "",
            prazo: evento.prazo || null,
            status: evento.status || "Aberta",
            atualizadoEm: serverTimestamp(),
          });


      history.goBack();
    } catch (e) {
      console.error(e);
      setErro("Erro ao salvar tratamento");
    } finally {
      setSalvando(false);
    }
  }

  /* =========================
     RENDER
  ========================= */
  if (loading) {
    return (
      <>
        <Navbar />
        <div className="container mt-4 text-center">
          <CircularProgress />
        </div>
      </>
    );
  }

  if (erro) {
    return (
      <>
        <Navbar />
        <div className="container mt-4">
          <div className="alert alert-warning">{erro}</div>
          <Button onClick={() => history.goBack()}>Voltar</Button>
        </div>
      </>
    );
  }

  if (exibirRelatorio) {
    return (
      <RelatorioOcorrenciasPrint
        registros={[evento]}
        individual
        onVoltar={() => setExibirRelatorio(false)}
      />
    );
  }

  return (
    <>
      <Navbar />

      <div className="container mt-4" style={{ maxWidth: 900 }}>
        <h4>Tratamento da Ocorrência</h4>

        <Paper className="p-3 mt-3">
          <Chip
            label={evento.tipoRegistro}
            color={evento.tipoRegistro === "NC" ? "error" : "info"}
            size="small"
          />

          <p className="mt-2">
            <b>Relato:</b>
            <br />
            {evento.descricao}
          </p>

          {/* REFERÊNCIA */}
            <TextField
              fullWidth
              label="Referência (local, área, processo, etc.)"
              margin="normal"
              value={evento.referencia || ""}
              onChange={(e) =>
                setEvento({ ...evento, referencia: e.target.value })
              }
            />


          {evento.imagemUrl && (
            <p>
              <a
                href={evento.imagemUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                📎 Ver evidência
              </a>
            </p>
          )}

          {/* CLASSIFICAÇÃO */}
          <TextField
            select
            fullWidth
            label="Classificação"
            margin="normal"
            value={evento.classificacao || ""}
            onChange={(e) =>
              setEvento({ ...evento, classificacao: e.target.value })
            }
          >
            <MenuItem value="Leve">Leve</MenuItem>
            <MenuItem value="Moderada">Moderada</MenuItem>
            <MenuItem value="Grave">Grave</MenuItem>
          </TextField>

          {/* 👉 TIPO DA NÃO CONFORMIDADE */}
          {evento.tipoRegistro === "NC" && (
            <TextField
              select
              fullWidth
              label="Tipo da Não Conformidade"
              margin="normal"
              value={evento.tipoNC || ""}
              onChange={(e) =>
                setEvento({ ...evento, tipoNC: e.target.value })
              }
            >
              <MenuItem value="Procedimento">Procedimento</MenuItem>
              <MenuItem value="Equipamento">Equipamento</MenuItem>
              <MenuItem value="Treinamento">Treinamento</MenuItem>
              <MenuItem value="Documentacao">Documentação</MenuItem>
              <MenuItem value="Seguranca do Trabalho">
                Segurança do Trabalho
              </MenuItem>
              <MenuItem value="Comportamental">Comportamental</MenuItem>
              <MenuItem value="Fornecedor">Fornecedor</MenuItem>
              <MenuItem value="Metodo">Método</MenuItem>
              <MenuItem value="Meio Ambiente">Meio Ambiente</MenuItem>
            </TextField>
          )}

          {/* CAUSA */}
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Causa"
            margin="normal"
            value={evento.causa || ""}
            onChange={(e) =>
              setEvento({ ...evento, causa: e.target.value })
            }
          />

          {/* AÇÃO CORRETIVA */}
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Ação Corretiva"
            margin="normal"
            value={evento.acaoCorretiva || ""}
            onChange={(e) =>
              setEvento({ ...evento, acaoCorretiva: e.target.value })
            }
          />

          {/* AÇÃO PREVENTIVA */}
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Ação Preventiva"
            margin="normal"
            value={evento.acaoPreventiva || ""}
            onChange={(e) =>
              setEvento({ ...evento, acaoPreventiva: e.target.value })
            }
          />

          {/* PRAZO */}
          <TextField
            type="date"
            fullWidth
            label="Prazo"
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={evento.prazo || ""}
            onChange={(e) =>
              setEvento({ ...evento, prazo: e.target.value })
            }
          />

          {/* STATUS */}
          <TextField
            select
            fullWidth
            label="Status"
            margin="normal"
            value={evento.status || "Aberta"}
            onChange={(e) =>
              setEvento({ ...evento, status: e.target.value })
            }
          >
            <MenuItem value="Aberta">Aberta</MenuItem>
            <MenuItem value="Em andamento">Em andamento</MenuItem>
            <MenuItem value="Encerrada">Encerrada</MenuItem>
          </TextField>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button variant="outlined" onClick={() => setExibirRelatorio(true)}>
              Imprimir
            </Button>

            <Button variant="outlined" onClick={() => history.goBack()}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={salvar}
              disabled={salvando}
            >
              {salvando ? "Salvando..." : "Salvar"}
            </Button>
          </div>
        </Paper>
      </div>
    </>
  );
}
